import React, { useEffect } from 'react'; // asegurate de importar useEffect
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';
import { getUsers, getTrainers } from '../../Redux/Actions/actions'; // IMPORTANTE

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const gym = useSelector(state => state.gym);
  const users = useSelector(state => state.users);
  const trainers = useSelector(state => state.trainers);

  // 👉 Cargar usuarios y entrenadores al montar
  useEffect(() => {
    dispatch(getUsers());
    dispatch(getTrainers());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <h1 className={styles.welcome}>¡Bienvenido, {gym?.owner_name || 'Usuario'}!</h1>

      <div className={styles.content}>
        <div className={styles.leftPanel}>
          <h2>Estadísticas</h2>
          <div className={styles.statBox}>
            <p><strong>Usuarios:</strong> {users?.length || 0}</p>
            <p><strong>Entrenadores:</strong> {trainers?.length || 0}</p>
          </div>
          <button onClick={() => navigate('/balances')} className={styles.buttonRed}>
            Balances
          </button>
        </div>

        <div className={styles.rightPanel}>
          <img src={gym?.logo_url} alt="Logo del gimnasio" className={styles.logo} />
          <h2 className={styles.gymName}>{gym?.name}</h2>
          <p><strong>Dirección:</strong> {gym?.address}</p>
          <p><strong>Email:</strong> {gym?.email}</p>
          <p><strong>Teléfono:</strong> {gym?.phone}</p>
          <p><strong>CUIT:</strong> {gym?.cuit}</p>
          <p><strong>Horario:</strong> {gym?.opening_time} a {gym?.closing_time}</p>
          <p><strong>Valor de la cuota:</strong> ${gym?.cuota_valor}</p>
          <p><strong>Descripción:</strong> {gym?.description}</p>
          <button onClick={() => navigate('/edit-gym')} className={styles.buttonRed}>
            Editar Datos
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
